module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh-bot",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Two weeks later")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("In the Boulder, Colorado, offices of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v(" magazine (Your Guide to Paranormal Destinations), two-thirds of the staff were having a fight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael Abernathy, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v("’s main writer, had the sardonic look of a Greek faun, with the addition of gold-rimmed glasses and blue jeans. He was arguing with Angus MacGregor, editor and cofounder of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping.")]), _vm._v(" A tall, rangy Scot in his early fifties, Angus had the warm smile and twinkling eyes of a kindly uncle, which was only slightly misleading.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael raised his voice another notch. “Leaving aside the question of intrinsic value, astrology columns are everywhere. What’s going to set ours apart?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus thought for a moment. “We’ll couch all the advice in terms of how it affects travel.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael looked over the top of his glasses. “So next to the article on ‘Best Haunted B&Bs,’ you’re going to say October is a good month for Virgo to stay home?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus ran a hand through his iron-gray hair. “Maybe we can focus on the paranormal aspect somehow.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How?” Michael adopted a girlish tone. “‘March is not the time to change your hairstyle, Sasquatch. If you need a pick-me-up, focus on those big feet and get a pedicure.’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus burst out laughing. “Perfect! Come up with eleven more and we’ll have the first batch done.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael groaned but made a note on his laptop. “All right, but I’m using a pseudonym.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki Oota, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v("’s photographer, wandered into the office carrying an iPad and a file folder. In a city where yoga-toned college students inflated the standard of looks, Suki still turned heads. Tall and half-Japanese, she wore her black hair in a short, spiky cut and favored red lipstick. Today she wore torn jeans over black leather boots with an array of buckles. A faux snakeskin tank top in red and black revealed her perfectly toned arms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael looked up. “What’s up with all the eyeliner? That’s not very steampunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I dropped the steam,” Suki drawled in her Los Angeles accent. She tossed the folder on Angus’s desk and slouched in the other chair. “Can we work on what features to do next?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Certainly.” Angus pulled the folder toward him and smiled benignly. “What are these?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Suggestions I got through e-mail.” Suki hooked one leg over the arm of her chair. “I don’t know what you guys already have.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael opened a document on his computer. “Somebody caught a giant squid with a tennis shoe on one of its tentacles. Oh, and there’s a new twist on those goats that faint when they hear a loud noise.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What kind of twist?” Angus asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Apparently some of them crap themselves, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki rolled her eyes. “Can’t wait to take those pictures.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus looked skeptical. “I’m not sure there’s anything paranormal about crapping goats.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Depends on "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("what")]), _vm._v(" they crap,” Michael pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus raised his eyebrows questioningly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael shrugged. “Sorry. It’s just regular crap.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus shuffled through the printed e-mails. “Let’s see what we have here. Ghost, turtle with an image of an alien on its shell, talking tree…” He read silently for a moment. “Looks like only one person can hear it. That’s a shame. Oh, here’s something. Mystery painting. Portrait of Doreene Gray to be sold.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It should be ‘picture’,” Michael said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus looked up. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oscar Wilde’s original title was "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Picture of Dorian Gray.")]), _vm._v(" People are always getting it wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus stared at him. “It must comfort your friends, knowing you’re always there to correct them.” He tapped the paper. “Considering this is an auction and not a book, and the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("portrait")]), _vm._v(" is of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Doreene")]), _vm._v(" Gray, I think Mr. Wilde is not under discussion.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I bet Doreene Gray isn’t her real name,” Michael said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus scanned the e-mail. “It has been ever since she married Mr. Gray. When the portrait was painted, she was Doreene Pinter. Bit of a lucky break there.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki heaved a sigh. “What’s the deal with the picture?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It ages but she doesn’t, or at least not much.” Angus swiveled his chair and began to type on his laptop’s keyboard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who painted the picture?” Michael asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doreene’s sister—"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("twin")]), _vm._v(" sister, Maureene, who ages normally.” Angus turned his computer so they could see the screen. “Here’s a photo of the two of them, taken eight years ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suki and Michael leaned forward and studied the photo. There was a strong resemblance between the two women, but they looked more like mother and daughter than twins.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“She’s probably had work done, but it’s really good,” Suki said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Michael rolled his eyes. “Of course she’s had work done. Do you think she owns an actual magic picture?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Michael…” Angus waved a hand around the office, gesturing to the framed covers of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Tripping")]), _vm._v(" magazine that decorated the walls. “May I remind you of our audience? Our mission is to present the uncanny for the public’s entertainment.” He picked up the e-mail and waved it. “We have a picture that changes over time, a woman who doesn’t, and best of all, we have twins. Twins are always interesting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s true.” Suki gave a languid smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What about the location?” Michael asked. “Do the sisters live in the same city? Is it a place people will want to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Absolutely.” Angus turned the laptop so he could type in a search string, then hit enter and turned it back to show them a harbor full of masted boats and a Victorian-era downtown. “Port Townsend, Washington. The land that time forgot. At least, it forgot for about seventy years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Does that mean they don’t have an airport?” Suki asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Angus shrugged. “I understand the drive from Seattle is beautiful.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0